import { IGetRestrictionsEndpoint } from "./GetRestrictionsEndpoint";
import { IGetCateringRestrictions } from "../CateringRestrictions/CateringRestrictionsRepository";
import { IUpdateCateringRestrictionsPayload, IUpdateEndpoint } from "./UpdateEndpoint";

export class CateringItemRestrictionRepository implements ICateringItemRestrictionRepository
{
    private updateEndpoint: IUpdateEndpoint;
    private getRestrictionsEndpoint: IGetRestrictionsEndpoint;

    constructor(
        updateEndpoint: IUpdateEndpoint,
        getRestrictionsEndpoint: IGetRestrictionsEndpoint,
    )
    {
        this.updateEndpoint = updateEndpoint
        this.getRestrictionsEndpoint = getRestrictionsEndpoint;
    }


    public update(buildingId: number,cateringMenuItemId:string, payload: IUpdateCateringRestrictionsPayload) : Promise<void>
    {
        return this.updateEndpoint.execute(buildingId,cateringMenuItemId,payload);
    }

    
    public getRestrictions(buildingId: number, cateringMenuItemId: string) : Promise<IGetCateringRestrictions>
    {
        return this.getRestrictionsEndpoint.execute(buildingId,cateringMenuItemId);
    }
}

export interface ICateringItemRestrictionRepository
{
    update(buildingId: number, cateringMenuItemId:string, payload: IUpdateCateringRestrictionsPayload): Promise<void>;
    getRestrictions(buildingId: number,cateringMenuItemId:string) : Promise<IGetCateringRestrictions>;
}

